import { ThemeType } from "@itwin/itwinui-react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GlobalSettings, LayoutState } from "types";

interface SettingsState {
  theme: ThemeType;
  layout: LayoutState;
  global: GlobalSettings;
}

const initialState: SettingsState = {
  theme: getFromLocalStorage(),
  layout: {},
  global: {},
}

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    themeChanged: (state, { payload }: PayloadAction<ThemeType>) => {
      state.theme = payload;
    },
    layoutStateChanged: (state, { payload }: PayloadAction<LayoutState>) => {
      if (payload.editorPanelSize !== undefined)
        state.layout.editorPanelSize = payload.editorPanelSize >= 10 && payload.editorPanelSize <= 90 ? payload.editorPanelSize : undefined;

      if (payload.filePanelSize !== undefined)
        state.layout.filePanelSize = payload.filePanelSize >= 10 && payload.filePanelSize <= 90 ? payload.filePanelSize : undefined;

      if (payload.mainHeader !== undefined)
        state.layout.mainHeader = payload.mainHeader;

      if (payload.editorPanel !== undefined)
        state.layout.editorPanel = payload.editorPanel;

      if (payload.editorLineNumbers !== undefined)
        state.layout.editorLineNumbers = payload.editorLineNumbers;

      if (payload.editorMiniMap !== undefined)
        state.layout.editorMiniMap = payload.editorMiniMap;

      if (payload.editorCodeFolding !== undefined)
        state.layout.editorCodeFolding = payload.editorCodeFolding;

      if (payload.filePanel !== undefined)
        state.layout.filePanel = payload.filePanel;

      if (payload.overviewPanel !== undefined)
        state.layout.overviewPanel = payload.overviewPanel;

      if (payload.packagesPanel !== undefined)
        state.layout.packagesPanel = payload.packagesPanel;

      if (payload.previewPanel !== undefined)
        state.layout.previewPanel = payload.previewPanel;

      if (payload.problemsPanel !== undefined)
        state.layout.problemsPanel = payload.problemsPanel;

      if (payload.walkthroughPanel !== undefined)
        state.layout.walkthroughPanel = payload.walkthroughPanel;

      if (payload.statusPanels !== undefined)
        state.layout.statusPanels = payload.statusPanels;

      if (payload.toolbars !== undefined)
        state.layout.toolbars = payload.toolbars;

      if (payload.popoutButton !== undefined)
        state.layout.popoutButton = payload.popoutButton;
    },
    globalSettingsChanged: (state, { payload }: PayloadAction<GlobalSettings>) => {
      if (payload.filePath && payload.filePath.length)
        payload.filePath = payload.filePath.map((item) => item.startsWith("/") ? item : `/${item}`);

      if (payload.activeFilePath)
        payload.activeFilePath = payload.activeFilePath.startsWith("/") ? payload.activeFilePath : `/${payload.activeFilePath}`;

      state.global = payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  themeChanged,
  layoutStateChanged,
  globalSettingsChanged
} = settingsSlice.actions;

export default settingsSlice.reducer;

// Helpers
function getFromLocalStorage() {
  const value = localStorage.getItem("theme") as ThemeType;

  if (value === "dark")
    return "dark"

  if (value === "light")
    return "light";

  return "dark";
}
